document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-careapex-cart-upsell-add]');

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    const form = button.closest('form');
    const variantId = form && form.querySelector('[name="id"]');

    if (!variantId || button.disabled) return;

    button.disabled = true;
    button.classList.add('is-loading');

    Shopify.addItem(variantId.value, 1, function () {
        Shopify.getCart(function (cart) {
            document.querySelectorAll('[data-cart-count]').forEach(function (count) {
                count.textContent = cart.item_count;
            });

            halo.updateQuickCart(cart);
        });
    });
});
